import React, { useEffect } from "react";
import { Form, Col, Button, Row, Container } from "react-bootstrap";
import { TextInput } from "../components/form.component";
import { FaPaperPlane } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";

const ReviewForm = ({ submitAction, detail = null }) => {
  const validationSchema = Yup.object({
    name: Yup.string().min(5).required(),
    paragraph: Yup.string().required(),
    image: Yup.string().required(),
    rating: Yup.number().min(1).max(5).required(),
  });
  let formik = useFormik({
    initialValues: {
      name: "",
      paragraph: "",
      image: "",
      rating: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log("submitted");
      submitAction(values);
    },
  });

  useEffect(() => {
    if (detail) {
      let data = {
        name: detail.name,
        paragraph: detail.paragraph,
        image: detail.name,
        rating: detail.rating,
      };
      formik.setValues({
        ...formik.values,
        ...data,
      });
    }
  }, [detail]);

  return (
    <>
      <Container
        fluid
        className="px-4 text-white"
        style={{ height: "50vh", background: "black" }}
      >
        <Row>
          <Col sm={12} md={12}>
            <h4 className="m-4 text-center"></h4>
          </Col>
        </Row>
        <Form onSubmit={formik.handleSubmit}>
          <TextInput
            label="Full Name"
            name="name"
            value={formik.values.name}
            changeEvent={formik.handleChange}
            placeholder="Enter Full Name"
            error={formik.errors.name}
          />
          <TextInput
            label="Review"
            name="paragraph"
            value={formik.values.paragraph}
            changeEvent={formik.handleChange}
            placeholder="Write your review.."
            error={formik.errors.paragraph}
          />
          <Form.Group className="row mb-3">
            <Form.Label className="col-sm-3">Images: </Form.Label>
            <Col sm={9}>
              <Form.Control
                type="file"
                size="sm"
                name="image"
                onChange={(e) => {
                  let file = e.target.files[0];
                  let ext = file.name.split(".").pop();

                  if (
                    [
                      "jpg",
                      "jpeg",
                      "png",
                      "gif",
                      "bmp",
                      "webp",
                      "svg",
                    ].includes(ext.toLowerCase())
                  ) {
                    formik.setValues({
                      ...formik.values,
                      image: file,
                    });
                  } else {
                    formik.setErrors({
                      ...formik.errors,
                      image: "File format not supported",
                    });
                  }
                }}
                accept="image/*"
              />
              <span className="text-danger">{formik.errors.image}</span>
            </Col>
          </Form.Group>
          <TextInput
            label="Rating"
            name="rating"
            type="number"
            value={formik.values.rating}
            changeEvent={formik.handleChange}
            required={true}
            placeholder="Please Rate us..."
            error={formik.errors.rating}
          />
          <Form.Group className="row mb-3">
            <Col sm={{ offset: 3, span: 9 }}>
              <Button
                variant="success"
                className="me-3"
                type="submit"
                size="sm"
              >
                <FaPaperPlane /> Submit
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Container>
    </>
  );
};

export default ReviewForm;
